var render = function render(){var _vm=this,_c=_vm._self._c;return _c('cssObject',{attrs:{"scale":_vm.scale,"position":_vm.position,"rotation":_vm.rotation,"name":_vm.name,"url":_vm.url,"size":_vm.size}})
}
var staticRenderFns = []

export { render, staticRenderFns }